import React from 'react';
import Layout from '../components/Layout';
import HeroSection from '../components/HeroSection';
import BrandsSection from '../components/BrandsSection';
import InteractiveTab from '../components/InteractiveTab';
import MobileHomePage from '../components/MobileHomePage';
import useMediaQuery from '../hooks/useMediaQuery';

const HomePage = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Layout>
      {isMobile ? <MobileHomePage /> : (
        <>
          <HeroSection />
          <BrandsSection />
          
          <section className="w-full px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 py-8 md:py-12 lg:py-16">
            <div className="max-w-screen-2xl w-[80%] mx-auto">
              <div className="mb-6 md:mb-8 lg:mb-12 px-2 md:px-0">
                <h1 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-tight">
                  <div 
                    className="mb-2 md:mb-3"
                    style={{
                      fontFamily: 'Bricolage Grotesque',
                      fontWeight: '300',
                      letterSpacing: '-1%',
                    }}
                  >
                    The Design Studio That Actually Delivers
                  </div>
                  <div style={{
                    fontFamily: 'Bricolage Grotesque',
                    fontWeight: '500',
                    letterSpacing: '-1%'
                  }}>
                    From Not Working → That Works
                  </div>
                </h1>
              </div>
            </div>
            <InteractiveTab />
          </section>
        </>
      )}
    </Layout>
  );
};

export default HomePage;